import { goBack } from 'react-router-redux'
import { takeLatest, put, all } from 'redux-saga/effects'

/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const DRAWER_DOCKED = 'DRAWER_DOCKED'
export const TOOGLE_PROFILE_DRAWER = 'TOOGLE_PROFILE_DRAWER'
export const TOGGLE_MENU_DRAWER = 'TOGGLE_MENU_DRAWER'

export const LIST_ITEMS_MENU_NEWS_REQUEST = 'LIST_ITEMS_MENU_NEWS_REQUEST'
export const LIST_ITEMS_MENU_NEWS_FAILURE = 'LIST_ITEMS_MENU_NEWS_FAILURE'
export const LIST_ITEMS_MENU_NEWS_SUCCESS = 'LIST_ITEMS_MENU_NEWS_SUCCESS'

export const SHOW_BACK_BUTTON = 'SHOW_BACK_BUTTON'
export const HIDE_BACK_BUTTON = 'HIDE_BACK_BUTTON'
export const DO_GO_BACK = 'DO_GO_BACK'

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const doGoBack = () => ({
  type: DO_GO_BACK
})
export const doShowBackButton = backLocation => ({
  type: SHOW_BACK_BUTTON,
  backLocation
})
export const doHideBackButton = () => ({
  type: HIDE_BACK_BUTTON
})
export const showNotification = (
  message,
  duration = 3000,
  refresh = false
) => ({
  type: SHOW_NOTIFICATION,
  message,
  duration,
  refresh
})

export const hideNotification = () => ({
  type: HIDE_NOTIFICATION
})

export const showLoading = () => ({
  type: SHOW_LOADING
})

export const hideLoading = () => ({
  type: HIDE_LOADING
})

export const dockDrawer = isDocked => ({
  type: DRAWER_DOCKED,
  isDocked
})

export const toggleMenu = isOpen => ({
  type: TOGGLE_MENU_DRAWER,
  isOpen
})

export const toggleProfile = isOpen => ({
  type: TOOGLE_PROFILE_DRAWER,
  isOpen
})

// export const getMenuNews = parentID => ({
//   type: LIST_ITEMS_MENU_NEWS_REQUEST,
//   parentID
// })

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [SHOW_NOTIFICATION]: (currentState, action) => ({
    ...currentState,
    isOpen: true,
    message: action.message,
    duration: action.duration,
    refresh: action.refresh
  }),
  [HIDE_NOTIFICATION]: (currentState, action) => ({
    ...currentState,
    isOpen: false,
    message: '',
    refresh: false
  }),
  [SHOW_LOADING]: (currentState, action) => ({
    ...currentState,
    isLoading: true
  }),
  [HIDE_LOADING]: (currentState, action) => ({
    ...currentState,
    isLoading: false
  }),
  [DRAWER_DOCKED]: (currentState, action) => ({
    ...currentState,
    drawerDocked: action.isDocked
  }),
  [TOGGLE_MENU_DRAWER]: (currentState, action) => ({
    ...currentState,
    openMenuDrawer: action.isOpen
  }),
  [TOOGLE_PROFILE_DRAWER]: (currentState, action) => ({
    ...currentState,
    openProfileDrawer: action.isOpen
  }),
  [LIST_ITEMS_MENU_NEWS_REQUEST]: (currentState, action) => ({
    ...currentState
  }),
  [LIST_ITEMS_MENU_NEWS_FAILURE]: (currentState, action) => ({
    ...currentState
  }),
  [LIST_ITEMS_MENU_NEWS_SUCCESS]: (currentState, action) => ({
    ...currentState,
    itemsMenuNews: action.items
  }),
  [SHOW_BACK_BUTTON]: (currentState, action) => ({
    ...currentState,
    showBackButton: true,
    backLocation: action.backLocation
  }),
  [HIDE_BACK_BUTTON]: (currentState, action) => ({
    ...currentState,
    showBackButton: false,
    backLocation: '/'
  }),
  [DO_GO_BACK]: (currentState, action) => ({
    ...currentState,
    showBackButton: false
  })
}
/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  showBackButton: false,
  backLocation: '/',
  isLoading: false,
  isOpen: false,
  message: '',
  duration: 5000,
  refresh: false,
  drawerDocked: false,
  openMenuDrawer: false,
  openProfileDrawer: false
  // itemsMenuNews: []
}

export default function notification(
  currentState = { ...initialState },
  action
) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}

function* onGoBack() {
  // const { backLocation } = yield select(state => state.global)
  // yield put(push(backLocation))
  yield put(goBack())
}
function* globalWatcher() {
  yield all([takeLatest(DO_GO_BACK, onGoBack)])
}

export const saga = [globalWatcher()]



// WEBPACK FOOTER //
// ./src/store/global.js